import brandConfig from "@/config/brandConfig";

// This plugin injects brand values as CSS custom properties and creates utility classes
export default {
  install(Vue) {
    const root = document.documentElement;

    // Create a style element for utility classes
    const styleEl = document.createElement("style");
    let utilityStyles = "";

    // Process each color group
    Object.entries(brandConfig.colors).forEach(([colorName, colorVariants]) => {
      Object.entries(colorVariants).forEach(([variant, value]) => {
        const variantSuffix = variant === "default" ? "" : `-${variant}`;
        const cssVarName = `--brand-${colorName}${variantSuffix}`;
        const className = `brand-${colorName}${variantSuffix}`;

        // Set CSS custom property
        root.style.setProperty(cssVarName, value);

        // Create utility classes
        utilityStyles += `
          .${className} { color: ${value} !important; }
          .${className}-bg { background-color: ${value} !important; }
          .${className}-border { border-color: ${value} !important; }
        `;
      });
    });

    // Add utility styles to document
    styleEl.innerHTML = utilityStyles;
    document.head.appendChild(styleEl);

    // Make brand config available on Vue prototype for template access
    Vue.prototype.$brand = brandConfig;
  },
};
